import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import WorkplaceOrderingSettingsCalendar from './WorkplaceOrderingSettingsCalendar';
import { store } from '../../store/store';
import { Provider } from 'react-redux';

loadDOMComponent({
	selector: 'react-workplace-ordering-settings-calendar',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<WorkplaceOrderingSettingsCalendar workplaceId={workplaceId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
